
import CPNavigation from '@/components/globals/CPNavigation.vue';
import CPGlobalAccountSelect from '@/components/globals/CPGlobalAccountSelect.vue';
import CPPageWrapper from '@/components/globals/CPPageWrapper.vue';
import CPFooter from '@/components/globals/CPFooter.vue';
import CPLegal from '@/components/globals/CPLegal.vue';
import CPModal from '@/components/globals/CPModal.vue';
import CPSplash from '@/components/globals/CPSplash.vue';
import CPLoader from '@/components/globals/CPLoader.vue';
import CPLoginAsToolbar from '@/components/globals/CPLoginAsToolbar.vue';

import CPBasketBuy from '@/components/basket/CPBasketBuy.vue';
import CPBasketSell from '@/components/basket/CPBasketSell.vue';
import CPDocumentModal from '@/components/basket/CPDocumentModal.vue';
import CPClientWatchlist from '@/components/globals/CPClientWatchlist.vue';
import CPCart from '@/components/basket/CPCart.vue';
import CPHphCartDisabledModal from '@/components/basket/CPHphCartDisabledModal.vue';
import CPWatchlist from '@/components/globals/CPWatchlist.vue';
import CPAlerts from '@/components/globals/CPAlerts.vue';
import CPFundDetails from '@/components/globals/CPFundDetails.vue';
import CPFundSummary from '@/components/globals/CPFundSummary.vue';
import CPTransactionDetails from '@/components/globals/CPTransactionDetails.vue';
import CPSnackBar from '@/components/globals/CPSnackBar.vue';
import CPProjections from '@/components/my-account/CPProjections.vue';
import CPBuySell from '@/components/dashboard/CPBuySell.vue';
import CPDealingInstructionsModal from '@/components/my-account/CPDealingInstructionsModal.vue';
import CPOpenAccountSourceOfFundsTable from '@/components/open-account/form/CPOpenAccountSourceOfFundsTable.vue';
import CPAccountSummaryOutOfDate from '@/components/globals/CPAccountSummaryOutOfDate.vue';
import CPUpdateDetailsReminder from '@/components/globals/CPUpdateDetailsReminder.vue';
import CPPortalNotification from '@/components/globals/CPPortalNotification.vue';

import { whitelabels, Whitelabel } from '@/utils/whitelabels';

import { Debounce } from 'vue-debounce-decorator';

import { Component, Vue, Watch } from 'vue-property-decorator';
import CPMissingDocumentsSummary from './components/globals/CPMissingDocumentSummary.vue';
import CPMissingDocuments from './components/globals/CPMissingDocuments.vue';
import CPKYC from './components/globals/CPKYC.vue';
import CPAppropriatenessTest from './components/globals/CPAppropriatenessTest.vue';
import CPSubmitIndicator from './components/globals/CPSubmitIndicator.vue';
import { USER_ROLES } from './utils/roles';
import CPDueDiligenceReminder from './components/dueDiligence/CPDueDiligenceReminder.vue';
import CPDueDiligenceReminderOverview from './components/dueDiligence/CPDueDiligenceReminderOverview.vue';
import CPDueDiligenceDocumentsOverview from './components/dueDiligence/CPDueDiligenceDocumentsOverview.vue';
import CPDueDiligenceConfirmation from './components/dueDiligence/CPDueDiligenceConfirmation.vue';
import { ENVIRONMENT } from './config';
import { startIdleLogout } from '@/utils/idle-logout';

@Component({
  components: {
    CPNavigation,
    CPGlobalAccountSelect,
    CPPageWrapper,
    CPFooter,
    CPLegal,
    CPModal,
    CPLoader,
    CPSplash,
    CPLoginAsToolbar,
    CPBasketBuy,
    CPBasketSell,
    CPDocumentModal,
    CPCart,
    CPHphCartDisabledModal,
    CPWatchlist,
    CPAlerts,
    CPSnackBar,
    CPFundDetails,
    CPFundSummary,
    CPProjections,
    CPBuySell,
    CPTransactionDetails,
    CPDealingInstructionsModal,
    CPClientWatchlist,
    CPOpenAccountSourceOfFundsTable,
    CPAccountSummaryOutOfDate,
    CPMissingDocumentsSummary,
    CPMissingDocuments,
    CPKYC,
    CPSubmitIndicator,
    CPAppropriatenessTest,
    CPUpdateDetailsReminder,
    CPPortalNotification,
    CPDueDiligenceReminder,
    CPDueDiligenceConfirmation,
    CPDueDiligenceReminderOverview,
    CPDueDiligenceDocumentsOverview,
  },
})
export default class App extends Vue {
  get modal() {
    return this.$store.state.modal;
  }

  get token() {
    return this.$store.state.account.token;
  }

  get companyCode() {
    return this.$store.state.account.details.companyCode;
  }

  get subdomain() {
    return this.$store.state.subdomain;
  }

  get portalNotificationModal() {
    return this.$store.state.portalNotificationModal;
  }

  get currentPortalNotification() {
    const queue = this.$store.state.portalNotifications || [];
    const index = this.$store.state.portalNotificationIndex || 0;
    return queue[index] || null;
  }

  get currentRoute() {
    return this.$route.name;
  }

  get expiry() {
    return this.$store.state.account.details.expiry;
  }

  get snackbar() {
    return this.$store.state.utils.snackbar;
  }

  get buySell() {
    return this.$store.state.buySell;
  }

  get modalActive() {
    if (
      this.modal.message !== '' ||
      this.$store.state.watchlist.open ||
      this.$store.state.alerts.open ||
      this.$store.state.fundDetailsModal.open ||
      this.$store.state.fundSummaryModal.open ||
      this.$store.state.userTransactions.open ||
      this.$store.state.baskets.buy.open ||
      this.$store.state.baskets.sell.open ||
      this.$store.state.baskets.cart.open ||
      this.$store.state.baskets.hphCartDisabledNotice ||
      this.$store.state.errors.length > 0 ||
      this.$store.state.utils.projectionModal ||
      (this.$store.state.baskets.documents &&
        this.$store.state.baskets.documents.GeneratePDF) ||
      this.$store.state.yieldCalculatorAdvanced ||
      this.buySell
    ) {
      return true;
    } else {
      return false;
    }
  }
  get changeActiveAccount() {
    if (
      this.$store.state.watchlist.open ||
      this.$store.state.alerts.open ||
      this.$store.state.userTransactions.open ||
      this.$store.state.baskets.buy.open ||
      this.$store.state.baskets.sell.open ||
      (this.$store.state.baskets.cart.open &&
        !this.$store.state.baskets.checkoutActive)
    ) {
      return true;
    } else {
      return false;
    }
  }
  public get domain(): any {
    if (ENVIRONMENT === 'local') {
      return 'ama-new.testurl.com';
    }
    return window.location.href;
  }

  public whitelabel: Whitelabel = whitelabels[0];
  private stopIdleLogout: (() => void) | null = null;

  @Watch('modalActive')
  public isModalVisible() {
    if (this.modalActive) {
      document.body.style.overflow = 'hidden';
      return;
    } else {
      document.body.style.overflow = 'auto';
    }
  }

  @Watch('token')
  public async onTokenReady(newToken: string | null) {
    if (!newToken) return;
    await this.$store.dispatch('setUserDetails', newToken);
    await this.$store.dispatch('dueDiligence/getMetadata');
    await this.getDueDiligenceReminder(
      this.$store.state.account.details.bostonId,
      this.$store.state.account.details.userId,
    );
  }

  @Watch('subdomain')
  public updateWhitelabel() {
    if (!this.subdomain) {
      this.whitelabel = whitelabels[0];
    } else {
      const companyIndex = whitelabels
        .map((x) => x.name())
        .indexOf(this.subdomain);
      this.whitelabel = whitelabels[companyIndex];
    }
  }

  @Debounce(1000)
  public getWindowWidth() {
    this.$store.commit('updateAppWidth', document.documentElement.clientWidth);
  }

  @Debounce(1000)
  public getWindowHeight() {
    this.$store.commit(
      'updateAppHeight',
      document.documentElement.clientHeight,
    );
  }

  public clearErrors() {
    this.$store.dispatch('addError', '');
  }

  // Gets subdomain E.G. 'AMA' in order to get css and images set.
  public getWhiteLabel() {
    const rgx: RegExp = /(?:http[s]*\:\/\/)*(.*?)\.(?=[^\/]*\..{2,5})/i;
    const whitelabel: any = this.domain.match(rgx)[1].replace('-new', '');
    if (
      whitelabel &&
      whitelabels.filter((item) => item.name() === whitelabel)[0]
    ) {
      this.$store.dispatch('setSubdomain', whitelabel);
    } else {
      this.$store.dispatch('setSubdomain', null);
      if (this.token) {
        this.$store.dispatch('logout');
      }
    }
  }
  public updateFaviconAndTitle() {
    // live URL
    const rgx: RegExp = /(?:http[s]*\:\/\/)*(.*?)\.(?=[^\/]*\..{2,5})/i;
    if (this.domain.match(rgx) && this.domain.match(rgx)[1]) {
      const whitelabel: any = this.domain.match(rgx)[1].replace('-new', '');

      if (whitelabel) {
        const el: HTMLLinkElement | null =
          document.querySelector('link[rel*="icon"]');
        if (whitelabels.filter((item) => item.name() === whitelabel)[0]) {
          document.title =
            whitelabels.filter((item) => item.name() === whitelabel)[0]
              .readable + ' - Login';
        } else {
          console.log('whitelabel not found');
          this.$store.dispatch(
            'addError',
            'Sorry, something went wrong while loading the page. Please refresh and check that your URL is valid',
          );
        }
        if (
          el !== null &&
          whitelabels.filter((item) => item.name() === whitelabel)[0]
        ) {
          el.href = whitelabels.filter(
            (item) => item.name() === whitelabel,
          )[0].favicon;
        }
      } else {
        console.log('not whitelabel');

        document.title = 'Login Page - error';
        this.$store.dispatch(
          'addError',
          'Sorry, something went wrong while loading the page. Please refresh and check that your URL is valid',
        );
      }
    } else {
      console.log("domain doens't matched");
      document.title = 'Login Page - error';
      this.$store.dispatch(
        'addError',
        'Sorry, something went wrong while loading the page. Please refresh and check that your URL is valid',
      );
    }
  }

  public addFonts() {
    setTimeout(() => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = this.whitelabel.fontURL;
      document.getElementsByTagName('head')[0].appendChild(link);
    }, 500);
  }

  public handleVisibilityChange() {
    if (!document.hidden && this.expiry) {
      // the page is visible
      if (this.expiry * 1000 < Date.now()) {
        this.$store.dispatch(
          'addError',
          'Sorry you have been logged out due to inactivity, please login again',
        );
        this.$store.dispatch('logout', { broadcast: true });
      }
    }
  }

  @Watch('token', { immediate: true })
  public onTokenIdleWatch(token: string | null) {
    if (this.stopIdleLogout) {
      this.stopIdleLogout();
      this.stopIdleLogout = null;
    }
    if (!token) return;

    this.stopIdleLogout = startIdleLogout(() => {
      this.$store.dispatch(
        'addError',
        'Sorry you have been logged out due to inactivity, please login again',
      );
      this.$store.dispatch('logout', { broadcast: true });
    });
  }

  public IsExternal() {
    const list = ['ResetPassword', 'Login'];

    return !list.some(
      (item) =>
        this.$router.currentRoute.name?.toLowerCase() === item.toLowerCase(),
    );
  }

  public checkMissingDocs() {
    // Check if account creation date is more than 6 weeks to date
    const [day, month, year] =
      this.$store.state.account.accountSummary[0].creationDate.split('-');
    const creationDate = new Date([month, day, year].join('/'));
    const today = new Date();
    const dateNow = new Date(
      [today.getMonth() + 1, today.getDate(), today.getFullYear()].join('/'),
    );
    const days = Math.floor(
      (Date.parse(dateNow.toDateString()) -
        Date.parse(creationDate.toDateString())) /
        86400000,
    );
    if (days >= 42) {
      // 42 = 6 weeks
      return true;
    }
    return false;
  }

  public hasMissingDocs() {
    // Check if account creation date is more than 6 weeks to date
    let res = false;
    this.$store.state.missingDocuments.list.forEach(
      (element: { Client: { CreationDate: string } }) => {
        const today = new Date();
        const dateNow = new Date(
          [today.getMonth() + 1, today.getDate(), today.getFullYear()].join(
            '/',
          ),
        );
        const days = Math.floor(
          (Date.parse(dateNow.toDateString()) -
            Date.parse(element.Client.CreationDate)) /
            86400000,
        );
        if (days >= 42) {
          // 42 = 6 weeks
          res = true;
        }
      },
    );
    return res;
  }

  public async mounted() {
    document.title = 'Login';
    this.updateFaviconAndTitle();

    this.$nextTick(function () {
      window.addEventListener('resize', this.getWindowWidth);
      window.addEventListener('resize', this.getWindowHeight);
      this.getWindowWidth();
      this.getWindowHeight();
    });
    // adds listener to check for valid token
    document.addEventListener(
      'visibilitychange',
      this.handleVisibilityChange,
      false,
    );
    await this.$store.dispatch('getToken');
    await this.$store.dispatch('getUsername');

    this.getWhiteLabel();
    this.addFonts();

    if (this.token) {
      await this.$store.dispatch('setUserDetails', this.token);
      await this.$store.dispatch('dueDiligence/getMetadata');
    }

    await this.getDueDiligenceReminder(
      this.$store.state.account.details.bostonId,
      this.$store.state.account.details.userId,
    );
  }

  public beforeDestroy() {
    window.removeEventListener('resize', this.getWindowWidth);
    window.removeEventListener('resize', this.getWindowHeight);
    document.removeEventListener(
      'visibilitychange',
      this.handleVisibilityChange,
    );
    if (this.stopIdleLogout) {
      this.stopIdleLogout();
      this.stopIdleLogout = null;
    }
  }

  private async getDueDiligenceReminder(
    bostonId: number | undefined,
    userinfoId: number | undefined,
  ): Promise<void> {
    if (!bostonId || this.$store.state.account?.details?.impersonator) return;
    const overviewModalCheck: boolean = await this.$store.dispatch(
      'dueDiligence/getOverviewModalCheck',
      this.$store.state.account.details.bostonId,
    );
    if (
      !this.$store.state.account.details.role.includes(USER_ROLES.CLIENT) &&
      overviewModalCheck
    ) {
      await this.$store.dispatch('dueDiligence/toggleReminderOverviewModal');
      return;
    }

    if (!this.IsExternal()) return;

    await this.$store.dispatch('dueDiligence/getUserReminder', bostonId);

    if (this.$store.state.dueDiligence.reminder.IsReminderDue) {
      await this.$store.dispatch('dueDiligence/getUserDetails', userinfoId);
      this.$store.dispatch('dueDiligence/toggleReminderModal');
    }
  }
}
